import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="ekrit-footer">
      <Container style={{ maxWidth: "1400px" }}>

        <div className="footer-top">

          <div className="footer-brand">

            <h2>EkritFly</h2>

            <p>
              Helping ambitious businesses align
              strategy, marketing and technology
              to create sustainable growth.
            </p>

          </div>

          <div className="footer-links-grid">

            <div className="footer-column">
              <h5>Services</h5>

              <Link to="/services">
                All Services
              </Link>

              <Link to="/services/marketing-consulting">
                Marketing Consulting
              </Link>

              <Link to="/services/seo-organic-growth">
                SEO & Organic Growth
              </Link>

              <Link to="/services/performance-marketing">
                Performance Marketing
              </Link>
            </div>

            <div className="footer-column">
              <h5>Industries</h5>

              <Link to="/industries">
                All Industries
              </Link>

              <Link to="/industries/real-estate">
                Real Estate
              </Link>

              <Link to="/industries/healthcare">
                Healthcare
              </Link>

              <Link to="/industries/saas">
                SaaS & Technology
              </Link>
            </div>

            <div className="footer-column">
              <h5>Resources</h5>

              <Link to="/blog">
                Blog
              </Link>

              <Link to="/case-studies">
                Case Studies
              </Link>

              <Link to="/about">
                About
              </Link>

              <Link to="/contact">
                Contact
              </Link>
            </div>

          </div>

        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">

          <div>
            © {new Date().getFullYear()} EkritFly
          </div>

          <div className="footer-contact">
            hello@ekritfly.com
          </div>

        </div>

      </Container>
    </footer>
  );
}

export default Footer;